<input id="input--layout--sidebar-right" class="hide" type="checkbox" checked="checked">
<div class="layout--sidebar-right layout--sidebar">
    <slot></slot>
</div>
